export const types = {
  products: "[GET] Products",
  addProducts: "[POST] Products",
  removeProducts: "[DELETE] Products",
};
